import { CompanyPolicyFilterOptions } from "../../enums/filters-and-searchs/company-poicy.filter.options";

export const CompanyPolicyFilterOptionsDetails = new Map<number, string>([
    [CompanyPolicyFilterOptions.None, 'None'],
    [CompanyPolicyFilterOptions.Deleted, 'Deleted company policy']
]);